import { render, staticRenderFns } from "./DocumentPage.vue?vue&type=template&id=01529267&scoped=true&"
import script from "./DocumentPage.vue?vue&type=script&lang=js&"
export * from "./DocumentPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPage.vue?vue&type=style&index=0&id=01529267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01529267",
  null
  
)

export default component.exports